import React from 'react';
import styled from 'styled-components';
import moment from "moment";
import { findDOMNode } from 'react-dom';
import { useState, useRef } from 'react';
import $ from 'jquery';
import { isMobileOnly } from 'react-device-detect';

const QuestionAccoLiBlock = styled.li`
    color : ${props => props.color};
    border-bottom: 1px solid #ccc;
    font-size: 14px;
`;

const QuestionAccoTitleboxBlock = styled.div`
    cursor: pointer;

    ::after {
        content: '';
        display: block;
        clear: both;
`;

const QuestionAccoTitleCateSpanBlock = styled.span`
    font-weight: 500;
    width: 10%;
    text-align: center;
    display: block;
    float: left;
    padding: 28px 0;
`;

const QuestionAccoTitleH4Block = styled.h4`
    width: 65%;
    display: block;
    float: left;
    padding: 28px 0;

    ${isMobileOnly&&`
        width : 50vw; /* 구식 브라우저를 위한 대비책(fallback) */
        width : -webkit-calc(100% - 200px); /* for Chrome, Safari */
        width : -moz-calc(100% - 200px); /* for Firefox */
        width : calc(100% - 200px); 
        display: block;
        float: left;
        padding: 28px 0;
    `};
`;

const QuestionAccoTitleDateSpanBlock = styled.span`
    width: 10%;
    display: block;
    float: left;
    padding: 28px 0;
`;

const QuestionAccoTitleActSpanBlock = styled.span`
    font-weight: 500;
    width: 10%;
    text-align: center;
    display: block;
    float: left;
    padding: 28px 0;
`;

const QuestionAccoTitleArrowSpanBlock = styled.span`
/* width: 5%;
    height: 70px;
    background: url(/assets/images/icon/da-icon.png) center center/auto no-repeat;
    display: block;
    float: left;
    padding: 28px 0; */
`;


const QuestionAccoConBoxBlock = styled.div`

`;

const QuestionAccoConQuestionBlock = styled.div`

`;

const QuestionAccoSectionPBlock = styled.p`

`;

const QuestionAccoConPBlock = styled.p`

`;

const QuestionAccoConImgConBlock = styled.div`
    margin-top : ${props => props.marginTop};
    ::after {
        content: '';
        display: block;
        clear: both;
`;

const QuestionAccoConImgBlock = styled.img`
    display : ${props => props.display};
    //max-width: 152px;
    float : left;
    
    cursor: pointer;
    width : 100px;
    height: 100px;
    ${isMobileOnly?`
    margin-right: 0.5vw;
  `:`
    margin-right: 20px;
  `};
`;

const QuestionAccoConAnswerBlock = styled.div`

`;

const QuestionAccoConAnswerPBlock = styled.p`

`;

const QuestionAccoConAnswerLineBlock = styled.div`
    height: 1px;
    border-top: 1px solid #ccc;
    padding-left: 30px;
    padding-right: 30px;
`;

const BuyOption = [
    { value: "125301", label: "배송" },
    { value: "125302", label: "주문" },
    { value: "125303", label: "결제" },
    { value: "125304", label: "교환" },
    { value: "125305", label: "반품" },
    { value: "125306", label: "취소" },
];

const NormalOption = [
    { value: "125401", label: "견적" },
    { value: "125402", label: "상품" },
    { value: "125403", label: "회원" },
    { value: "125404", label: "시스템 장애" },
    { value: "125405", label: "증빙서류" },
    { value: "125406", label: "기타" },
];

const QuestionAccoItem = ({ dataInfo, active, clickHandler }) => {
    const answerRef = useRef(null);
    //const [active, setActive] = useState(false);

    /*  const onClickTitle = ()=>{
         //console.log("onClickTitle")
         setActive(!active);
     } */

    const getTitleCate = () => {
        //console.log("dataInfo = " + JSON.stringify(dataInfo));
        let type = parseInt(dataInfo.cnslt_type);

        if (type < 125401) {
            return "구매문의";
        }

        return "일반문의";
    }

    const getAct = () => {
        if (dataInfo.cnslt_status === "120103") {
            return "답변완료";
        }

        return "미답변";
    }

    const getCate2 = () => {
        let type = parseInt(dataInfo.cnslt_type);

        if (type < 125401) {
            for (var i = 0; i < BuyOption.length; i++) {
                if (dataInfo.cnslt_type === BuyOption[i].value) {
                    return BuyOption[i].label;
                }
            }

        }
        else {
            for (var i = 0; i < NormalOption.length; i++) {
                if (dataInfo.cnslt_type === NormalOption[i].value) {
                    return NormalOption[i].label;
                }
            }
        }

    }

    const handleActiveClass = () => {
        if (answerRef.current) {
            const el = findDOMNode(answerRef.current);
            if (active) {
                $(el).slideDown();
                $(el).parents('li').addClass('active');
            }
            else {
                $(el).slideUp();
                $(el).parents('li').removeClass('active');
            }
        }
    }

    function image_popup(url) {

        var imgObj = new Image();
        imgObj.src = url;
        const y = window.top.outerHeight / 2 + window.top.screenY - (710 / 2);
        const x = window.top.outerWidth / 2 + window.top.screenX - (1096 / 2);

        imgObj.onload = function () {
            let height = this.height;
            let width = this.width;
            let top = (710 - height) / 2;
            let left = (1096 - width) / 2;
            if (top < 0) {
                top = 0;
            }
            if (left < 0) {
                left = 0;
            }
            //console.log("image popup height = " + height)
            //console.log("image popup width = " + width)
            let imageWin = window.open("", url, "width=1096px, height=710px" + ", top=" + y + " , left=" + x);

            //console.log("img = " + JSON.stringify(imgObj))
            imageWin.document.write("<html><body style='margin:0'>");
            imageWin.document.write("<div style='width: 1096px;height: 710px;'><a href=javascript:window.close()><img style='max-width: 1096px; padding: auto; margin: 0;position: absolute;top:" + top + "px;" + " left:" + left + "px;" + "' align=center src='" + imgObj.src + "' border=0></a></div>");
            imageWin.document.write("</body><html>");
            imageWin.document.title = imgObj.src;
        }

        //top=${y}, left=${x}

    }

    return (isMobileOnly ?
        <QuestionAccoLiBlock className={handleActiveClass()} >
            <QuestionAccoTitleboxBlock className="da-title-box" onClick={() => clickHandler(dataInfo.id)}>
                <QuestionAccoTitleCateSpanBlock style={{ width: '50px', height: '70px' }}>
                    {getCate2()}
                </QuestionAccoTitleCateSpanBlock>
                <QuestionAccoTitleH4Block className="da-title22" style={{ paddingLeft: '1vw', paddingRight: '1vw' }}>
                    {dataInfo.title}
                </QuestionAccoTitleH4Block>
                <QuestionAccoTitleDateSpanBlock className="da-date" style={{ width: '80px', textAlign: 'center' }}>
                    {moment(dataInfo.reg_dtm).format('YYYY.MM.DD')}
                </QuestionAccoTitleDateSpanBlock>
                <QuestionAccoTitleActSpanBlock style={{ width: '70px', textAlign: 'center' }}>
                    {getAct()}
                </QuestionAccoTitleActSpanBlock>
                {/* <QuestionAccoTitleArrowSpanBlock className="da-arrow" style={{ paddingTop: '20px', paddingBottom: '20px', width: '68px' }} /> */}
            </QuestionAccoTitleboxBlock>
            <QuestionAccoConBoxBlock ref={answerRef} className="da-con-box qna" style={{ paddingLeft: '2vw', paddingRight: '2vw' }}>
                <QuestionAccoConQuestionBlock className="da-con question" style={{ width: '90vw', paddingLeft: '11vw', paddingRight: '2vw' }}>
                    <QuestionAccoSectionPBlock className="section-nav margin_b-20"><span style={{ marginRight: '10px' }}>{getTitleCate()}</span> &gt; <span style={{ marginLeft: '10px' }}>{getCate2()}</span></QuestionAccoSectionPBlock>
                        <QuestionAccoConPBlock /* className="margin_b-30" */>
                            {
                                (dataInfo.question !== null && typeof(dataInfo.question) === "string" && dataInfo.question.length > 0 && dataInfo.question.indexOf("\n") > -1 ? dataInfo.question.split("\n").map(function(item, idx) {
                                return (
                                    <span key={idx}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                                }) : dataInfo.question)
                            }
                        </QuestionAccoConPBlock>
                    <QuestionAccoConImgConBlock marginTop={dataInfo.img1_url && dataInfo.img1_url.length > 0 ? '30px' : '0px'}>
                        <QuestionAccoConImgBlock src={dataInfo.img1_url} style={dataInfo.img1_url && dataInfo.img1_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img1_url)}></QuestionAccoConImgBlock>
                        <QuestionAccoConImgBlock src={dataInfo.img2_url} style={dataInfo.img2_url && dataInfo.img2_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img2_url)}></QuestionAccoConImgBlock>
                        <QuestionAccoConImgBlock src={dataInfo.img3_url} style={dataInfo.img3_url && dataInfo.img3_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img3_url)}></QuestionAccoConImgBlock>
                    </QuestionAccoConImgConBlock>
                </QuestionAccoConQuestionBlock>
                <QuestionAccoConAnswerLineBlock style={dataInfo.cnslt_status === "120103" ? { display: 'block' } : { display: 'none' }} />
                <QuestionAccoConAnswerBlock className="da-con answer" style={dataInfo.cnslt_status === "120103" ? { display: 'block', width: '90vw', paddingLeft: '11vw', paddingRight: '2vw', borderTop: '0px' } : { display: 'none' }} >
                    <QuestionAccoConAnswerPBlock>
                        {
                            (dataInfo.answer !== null && typeof(dataInfo.answer) === "string" && dataInfo.answer.length > 0 && dataInfo.answer.indexOf("\n") > -1 ? dataInfo.answer.split("\n").map(function(item, idx) {
                                return (
                                    <span key={idx}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                            }) : dataInfo.answer)
                        }
                    </QuestionAccoConAnswerPBlock>
                </QuestionAccoConAnswerBlock>
            </QuestionAccoConBoxBlock>
        </QuestionAccoLiBlock>
        :
        <QuestionAccoLiBlock className={handleActiveClass()} >
            <QuestionAccoTitleboxBlock className="da-title-box" onClick={() => clickHandler(dataInfo.id)}>
                <QuestionAccoTitleCateSpanBlock style={{ width: '90px', height: '70px' }}>
                    {getCate2()}
                </QuestionAccoTitleCateSpanBlock>
                <QuestionAccoTitleH4Block className="da-title" style={{ width: '568px', paddingLeft: '20px', paddingRight: '20px' }}>
                    {dataInfo.title}
                </QuestionAccoTitleH4Block>
                <QuestionAccoTitleDateSpanBlock className="da-date" style={{ width: '120px', textAlign: 'center' }}>
                    {moment(dataInfo.reg_dtm).format('YYYY.MM.DD')}
                </QuestionAccoTitleDateSpanBlock>
                <QuestionAccoTitleActSpanBlock style={{ width: '90px', textAlign: 'center' }}>
                    {getAct()}
                </QuestionAccoTitleActSpanBlock>
                <QuestionAccoTitleArrowSpanBlock className="da-arrow" style={{ paddingTop: '20px', paddingBottom: '20px', width: '68px' }} />
            </QuestionAccoTitleboxBlock>
            <QuestionAccoConBoxBlock ref={answerRef} className="da-con-box qna" style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                <QuestionAccoConQuestionBlock className="da-con question" style={{ width: '628px', paddingLeft: '80px', paddingRight: '20px' }}>
                    <QuestionAccoSectionPBlock className="section-nav margin_b-20"><span style={{ marginRight: '10px' }}>{getTitleCate()}</span> &gt; <span style={{ marginLeft: '10px' }}>{getCate2()}</span></QuestionAccoSectionPBlock>
                        <QuestionAccoConPBlock /* className="margin_b-30" */>
                            {
                                (dataInfo.question !== null && typeof(dataInfo.question) === "string" && dataInfo.question.length > 0 && dataInfo.question.indexOf("\n") > -1 ? dataInfo.question.split("\n").map(function(item, idx) {
                                return (
                                    <span key={idx}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                                }) : dataInfo.question)
                            }
                        </QuestionAccoConPBlock>
                    <QuestionAccoConImgConBlock marginTop={dataInfo.img1_url && dataInfo.img1_url.length > 0 ? '30px' : '0px'}>
                        <QuestionAccoConImgBlock src={dataInfo.img1_url} style={dataInfo.img1_url && dataInfo.img1_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img1_url)}></QuestionAccoConImgBlock>
                        <QuestionAccoConImgBlock src={dataInfo.img2_url} style={dataInfo.img2_url && dataInfo.img2_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img2_url)}></QuestionAccoConImgBlock>
                        <QuestionAccoConImgBlock src={dataInfo.img3_url} style={dataInfo.img3_url && dataInfo.img3_url.length > 0 ? { display: 'block', border: '1px solid #ccc', borderRadius: '4px', objectFit: 'cover' } : { display: 'none' }} onClick={() => image_popup(dataInfo.img3_url)}></QuestionAccoConImgBlock>
                    </QuestionAccoConImgConBlock>
                </QuestionAccoConQuestionBlock>
                <QuestionAccoConAnswerLineBlock style={dataInfo.cnslt_status === "120103" ? { display: 'block' } : { display: 'none' }} />
                <QuestionAccoConAnswerBlock className="da-con answer" style={dataInfo.cnslt_status === "120103" ? { display: 'block', width: '628px', paddingLeft: '80px', paddingRight: '20px', borderTop: '0px' } : { display: 'none' }} >
                    <QuestionAccoConAnswerPBlock>
                        {
                            (dataInfo.answer !== null && typeof(dataInfo.answer) === "string" && dataInfo.answer.length > 0 && dataInfo.answer.indexOf("\n") > -1 ? dataInfo.answer.split("\n").map(function(item, idx) {
                                return (
                                    <span key={idx}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                            }) : dataInfo.answer)
                        }
                    </QuestionAccoConAnswerPBlock>
                </QuestionAccoConAnswerBlock>
            </QuestionAccoConBoxBlock>
        </QuestionAccoLiBlock>

    );
};

export default QuestionAccoItem;
